import React, { useEffect, useState } from 'react';
import StoreIcon from '@mui/icons-material/Store';
import StarIcon from '@mui/icons-material/Star';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { SellerDetail } from './SellerDetail';
import { colorPalette } from '../../../colorPalette';
import { Drawer } from '../Drawer';
import { Button } from '../../Button';
import { SellerReview } from './SellerReview';
export const SellerDrawer = ({ open, onClose, title, target, seller, reviews, sellerCertification, sellerDescription, setTarget, setSortType, setSortOrder, setNextToken, getMoreReviews, setReviews, hasMoreReview, sellerLogin, showFavorite, isFavorite, firstTabTitle, secondTabTitle, sellerType, favoriteButtonText, memberText, replyText, acceptanceRateText, expeditionText, sortText, commentText, loadMoreText, translatedOptions, newVendorText, saleText, salesText, largeSalesText, textOn, ctaText, theText, certification, legalMentions, partnership, siren, vat, form, capital, idu, aboutUsText, email, handleFavorite, }) => {
    const [selectedTab, setSelectedTab] = useState(target === 'review' ? 1 : 0);
    const [tabs, setTabs] = useState();
    const [isLandingPage, setIsLandingPage] = useState(true);
    const [loading, setLoading] = useState(true);
    const boutiqueUrl = `${(seller === null || seller === void 0 ? void 0 : seller.sellerLoginWithCase) || (seller === null || seller === void 0 ? void 0 : seller.eshopName) || sellerLogin}`;
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const mainUrl = window.location.pathname;
            if (mainUrl.includes(boutiqueUrl.toLowerCase()) || mainUrl.includes(boutiqueUrl)) {
                setIsLandingPage(true);
            }
            else {
                setIsLandingPage(false);
            }
        }
        setLoading(false);
    }, [boutiqueUrl]);
    useEffect(() => {
        if (target === 'detail') {
            setSelectedTab(0);
        }
        else {
            setSelectedTab(1);
        }
    }, [target]);
    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [open]);
    useEffect(() => {
        if (!(seller === null || seller === void 0 ? void 0 : seller.isCrew)) {
            setTabs([
                {
                    label: (React.createElement(Stack, { alignItems: "center", direction: "row", spacing: 1 },
                        React.createElement(StoreIcon, { sx: {
                                fontSize: '20px',
                                color: selectedTab === 1 ? colorPalette.gray300 : colorPalette.gray700,
                            } }),
                        React.createElement(Typography, null, firstTabTitle || 'Détails vendeur'))),
                    value: 0,
                    children: (React.createElement(SellerDetail, { seller: seller, sellerCertification: sellerCertification, sellerDescription: sellerDescription, showFavorite: showFavorite, isFavorite: isFavorite, handleFavorite: handleFavorite, sellerType: sellerType, favoriteButtonText: favoriteButtonText, memberText: memberText, replyText: replyText, acceptanceRateText: acceptanceRateText, expeditionText: expeditionText, theText: theText, legalMentions: legalMentions, partnership: partnership, siren: siren, vat: vat, form: form, capital: capital, idu: idu, aboutUsText: aboutUsText, certification: certification, email: email })),
                },
                {
                    label: (React.createElement(Stack, { alignItems: "center", direction: "row", spacing: 1 },
                        React.createElement(StarIcon, { sx: {
                                fontSize: '20px',
                                color: selectedTab === 0 ? colorPalette.gray300 : colorPalette.yellow500,
                            } }),
                        React.createElement(Typography, null, secondTabTitle || 'Avis sur le vendeur'))),
                    value: 1,
                    disabled: reviews ? false : true,
                    children: (React.createElement(SellerReview, { seller: seller, sellerType: sellerType, sortText: sortText, commentText: commentText, loadMoreText: loadMoreText, translatedOptions: translatedOptions, newVendorText: newVendorText, saleText: saleText, salesText: salesText, largeSalesText: largeSalesText, textOn: textOn, reviews: reviews === null || reviews === void 0 ? void 0 : reviews.ratings, setNextToken: setNextToken, setSortOrder: setSortOrder, setSortType: setSortType, setReviews: setReviews, getMoreReviews: getMoreReviews, hasMoreReview: hasMoreReview })),
                },
            ]);
        }
        else {
            setTabs([
                {
                    label: (React.createElement(Stack, { alignItems: "center", direction: "row", spacing: 1 },
                        React.createElement(StoreIcon, { sx: {
                                fontSize: '20px',
                                color: selectedTab === 1 ? colorPalette.gray300 : colorPalette.gray700,
                            } }),
                        React.createElement(Typography, null, "D\u00E9tails vendeur"))),
                    value: 0,
                    children: (React.createElement(SellerDetail, { seller: seller, sellerCertification: sellerCertification, sellerDescription: sellerDescription, sellerType: sellerType, favoriteButtonText: favoriteButtonText, memberText: memberText, replyText: replyText, acceptanceRateText: acceptanceRateText, expeditionText: expeditionText, theText: theText, legalMentions: legalMentions, partnership: partnership, siren: siren, vat: vat, form: form, capital: capital, idu: idu, aboutUsText: aboutUsText, certification: certification, email: email })),
                },
            ]);
        }
    }, [seller, selectedTab, reviews, sellerCertification, isFavorite]);
    const onChangeTab = (index) => {
        if (index === 0) {
            setTarget('detail');
        }
        else {
            setTarget('review');
        }
    };
    if (loading) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Drawer, { open: open, onClose: onClose, title: title, tabsProps: {
            variant: 'fullWidth',
            indicatorColor: 'secondary',
            textColor: 'secondary',
        }, contentMargin: false, selectedTab: selectedTab, onChangeTab: onChangeTab, tabs: tabs, footer: !isLandingPage &&
            React.createElement(Button, { variant: "contained", fullWidth: true, href: `/boutique/${boutiqueUrl}` }, ctaText || 'Voir la boutique') }));
};
